import {
  IDestinationCountry,
  IHomeCountry,
} from '@nibtravel/shared/util/models';

export interface ICountriesConfig {
  expirySeconds: number;
  homeCountries: IHomeCountry[];
  destinationCountries: IDestinationCountry[];
  destinationCountriesSelect: Record<string, any>[];
  destinationRegions: IDestinationCountry[];
  destinationRegionsSelect: Record<string, any>[];
}

export const defaultCountriesState = {
  expirySeconds: 0,
  destinationCountriesSelect: [],
  destinationCountries: [],
  destinationRegionsSelect: [],
  destinationRegions: [],
  homeCountries: [],
};
